import script from "./subscribe-help.vue?vue&type=script&setup=true&lang=ts"
export * from "./subscribe-help.vue?vue&type=script&setup=true&lang=ts"

import "./subscribe-help.vue?vue&type=style&index=0&id=47287fcc&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47287fcc"]])

export default __exports__